// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/campaign.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { BranchTrigger, DateRange, Money, Ownership, Pagination, PaginationMeta, TagRef } from "./common_pb.js";
import { MetricFilter, StatsRow } from "./reporting_pb.js";
import { StatsSortOptions } from "./analytics_pb.js";
import { CampaignWhite, WhiteAssignment } from "./white_pool_pb.js";
import { TrafficSourceKind } from "./traffic_source_pb.js";

/**
 * What a buyer's flow rule looks at.
 *
 * @generated from enum tracker.v1.CampaignRuleMatch
 */
export enum CampaignRuleMatch {
  /**
   * @generated from enum value: CAMPAIGN_RULE_MATCH_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The visitor's country is one of values (ISO 3166-1 alpha-2).
   *
   * @generated from enum value: CAMPAIGN_RULE_MATCH_COUNTRY_IN = 1;
   */
  COUNTRY_IN = 1,

  /**
   * The visitor's country is none of values.
   *
   * @generated from enum value: CAMPAIGN_RULE_MATCH_COUNTRY_NOT_IN = 2;
   */
  COUNTRY_NOT_IN = 2,

  /**
   * The device class from the user agent is one of values: mobile, tablet,
   * desktop.
   *
   * @generated from enum value: CAMPAIGN_RULE_MATCH_DEVICE = 3;
   */
  DEVICE = 3,

  /**
   * Not a person: the traffic class (decision 01) is anything but human —
   * verified bot, Meta crawler, crawler user agent, no user agent, data centre.
   *
   * @generated from enum value: CAMPAIGN_RULE_MATCH_BOT = 4;
   */
  BOT = 4,

  /**
   * The workspace's local time is in [hour_from, hour_to) on one of weekdays.
   *
   * @generated from enum value: CAMPAIGN_RULE_MATCH_SCHEDULE = 5;
   */
  SCHEDULE = 5,

  /**
   * The link's query parameter param_name is absent or is not param_value:
   * the campaign's entry key. The ad link carries it; a visit without it
   * goes to the rule's target (typically a neutral page).
   *
   * @generated from enum value: CAMPAIGN_RULE_MATCH_PARAM_NOT_EQUAL = 6;
   */
  PARAM_NOT_EQUAL = 6,

  /**
   * A field of the visit (field: region, city, isp, asn, os, browser,
   * device_type, language, ip, user_agent, referrer, country, param:<name>)
   * holds op (in, not_in, contains, not_contains, regex, not_regex) over
   * values — FieldMatch, served the same on the edge and in the replay.
   *
   * @generated from enum value: CAMPAIGN_RULE_MATCH_FIELD = 7;
   */
  FIELD = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(CampaignRuleMatch)
proto3.util.setEnumType(CampaignRuleMatch, "tracker.v1.CampaignRuleMatch", [
  { no: 0, name: "CAMPAIGN_RULE_MATCH_UNSPECIFIED" },
  { no: 1, name: "CAMPAIGN_RULE_MATCH_COUNTRY_IN" },
  { no: 2, name: "CAMPAIGN_RULE_MATCH_COUNTRY_NOT_IN" },
  { no: 3, name: "CAMPAIGN_RULE_MATCH_DEVICE" },
  { no: 4, name: "CAMPAIGN_RULE_MATCH_BOT" },
  { no: 5, name: "CAMPAIGN_RULE_MATCH_SCHEDULE" },
  { no: 6, name: "CAMPAIGN_RULE_MATCH_PARAM_NOT_EQUAL" },
  { no: 7, name: "CAMPAIGN_RULE_MATCH_FIELD" },
]);

/**
 * @generated from enum tracker.v1.CampaignStatus
 */
export enum CampaignStatus {
  /**
   * @generated from enum value: CAMPAIGN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CAMPAIGN_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: CAMPAIGN_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: CAMPAIGN_STATUS_PAUSED = 3;
   */
  PAUSED = 3,

  /**
   * @generated from enum value: CAMPAIGN_STATUS_ARCHIVED = 4;
   */
  ARCHIVED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(CampaignStatus)
proto3.util.setEnumType(CampaignStatus, "tracker.v1.CampaignStatus", [
  { no: 0, name: "CAMPAIGN_STATUS_UNSPECIFIED" },
  { no: 1, name: "CAMPAIGN_STATUS_DRAFT" },
  { no: 2, name: "CAMPAIGN_STATUS_ACTIVE" },
  { no: 3, name: "CAMPAIGN_STATUS_PAUSED" },
  { no: 4, name: "CAMPAIGN_STATUS_ARCHIVED" },
]);

/**
 * CostModel is how a campaign's spend is counted (board Metrics, «Расход»):
 *   AUTO     the ad platform's spend per ad and day (pushed by vibe-fb into
 *            ad_cost_daily), spread over that ad's visits of the cabinet's day;
 *   CPC      default_cost per visit, stamped on the click when it happened;
 *   CPA      default_cost per approved lead;
 *   REVSHARE default_cost percent of the revenue;
 *   MANUAL   amounts entered for a period (AddCampaignCost), spread over the
 *            period's days and each day's visits.
 * Spend that has no visit to land on is «расход без кликов».
 *
 * @generated from enum tracker.v1.CostModel
 */
export enum CostModel {
  /**
   * @generated from enum value: COST_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COST_MODEL_CPC = 1;
   */
  CPC = 1,

  /**
   * @generated from enum value: COST_MODEL_CPA = 3;
   */
  CPA = 3,

  /**
   * @generated from enum value: COST_MODEL_REVSHARE = 4;
   */
  REVSHARE = 4,

  /**
   * @generated from enum value: COST_MODEL_AUTO = 5;
   */
  AUTO = 5,

  /**
   * @generated from enum value: COST_MODEL_MANUAL = 6;
   */
  MANUAL = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(CostModel)
proto3.util.setEnumType(CostModel, "tracker.v1.CostModel", [
  { no: 0, name: "COST_MODEL_UNSPECIFIED" },
  { no: 1, name: "COST_MODEL_CPC" },
  { no: 3, name: "COST_MODEL_CPA" },
  { no: 4, name: "COST_MODEL_REVSHARE" },
  { no: 5, name: "COST_MODEL_AUTO" },
  { no: 6, name: "COST_MODEL_MANUAL" },
]);

/**
 * Campaign supersedes the legacy Stream + edge.Campaign split. A Campaign
 * binds a TrafficSource + Flow + TrackingDomain and is the unit of
 * reporting, alerting, and click ingestion.
 *
 * @generated from message tracker.v1.Campaign
 */
export class Campaign extends Message<Campaign> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string traffic_source_id = 4;
   */
  trafficSourceId = "";

  /**
   * @generated from field: string flow_id = 5;
   */
  flowId = "";

  /**
   * @generated from field: string tracking_domain_id = 6;
   */
  trackingDomainId = "";

  /**
   * /clk/{token}
   *
   * @generated from field: string token = 7;
   */
  token = "";

  /**
   * @generated from field: tracker.v1.CampaignStatus status = 8;
   */
  status = CampaignStatus.UNSPECIFIED;

  /**
   * How the campaign's spend is counted. default_cost is the model's rate:
   * the price per click (CPC), per approved lead (CPA), or the percent of the
   * revenue (REVSHARE, 30 = 30%); unused by AUTO and MANUAL.
   *
   * @generated from field: tracker.v1.CostModel cost_model = 9;
   */
  costModel = CostModel.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.Money default_cost = 10;
   */
  defaultCost?: Money;

  /**
   * @generated from field: tracker.v1.CampaignSchedule schedule = 11;
   */
  schedule?: CampaignSchedule;

  /**
   * Layered context merged after flow/branch overrides at click time.
   *
   * @generated from field: map<string, string> additional_context = 12;
   */
  additionalContext: { [key: string]: string } = {};

  /**
   * @generated from field: string notes = 13;
   */
  notes = "";

  /**
   * @generated from field: repeated tracker.v1.TagRef tags = 14;
   */
  tags: TagRef[] = [];

  /**
   * @generated from field: tracker.v1.Ownership ownership = 15;
   */
  ownership?: Ownership;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt = "";

  /**
   * @generated from field: int64 revision = 31;
   */
  revision = protoInt64.zero;

  /**
   * Static ad-safe entry slug: the edge serves the campaign's lander inline
   * (HTTP 200, no redirect) at https://{tracking_domain}/{public_path}/.
   * Unique per tracking domain among live campaigns. Auto-minted from the
   * name on create when a tracking domain is set; editable.
   *
   * @generated from field: string public_path = 19;
   */
  publicPath = "";

  /**
   * Template-driven managed routing. A non-technical user picks a
   * developer-authored FlowTemplate (flow_template_id) + their weighted offers
   * and landers, and the service regenerates the campaign's flow from them on
   * every save — the user never authors the flow graph. Non-empty
   * flow_template_id marks a managed campaign; flow_id then names the generated
   * (read-only) flow. template_bindings carries scalar params (geo/text) only
   * for templates that declare them.
   *
   * @generated from field: string flow_template_id = 23;
   */
  flowTemplateId = "";

  /**
   * @generated from field: repeated tracker.v1.OfferWeight offer_weights = 24;
   */
  offerWeights: OfferWeight[] = [];

  /**
   * @generated from field: repeated tracker.v1.LanderWeight lander_weights = 25;
   */
  landerWeights: LanderWeight[] = [];

  /**
   * @generated from field: map<string, string> template_bindings = 26;
   */
  templateBindings: { [key: string]: string } = {};

  /**
   * What this campaign has answered for its platform, keyed by the ask-field
   * keys the source's own spec declares (internal/sourcetype — `pixel` for all
   * three ad platforms today, each with a DIFFERENT rule).
   *
   * There is deliberately no per-value pattern here. A rule that holds for
   * every platform at once is exactly the thing this field replaced: the shape
   * of an answer belongs to the platform that asks for it, so it is declared
   * in the source spec and enforced by that platform's adapter
   * (internal/adplatform), which returns a FieldError named after the ask
   * field — the SPA then paints the message under the input that broke.
   * The bounds below are anti-abuse only, not domain rules.
   *
   * @generated from field: map<string, string> platform_params = 29;
   */
  platformParams: { [key: string]: string } = {};

  /**
   * The managed campaign's monetisation branches (ADR 0002, phase 4): what a
   * visitor is sent to on Back, exit intent, idle or scroll end. Each becomes a
   * BRANCH root of the generated flow. One per trigger. Ignored on a campaign
   * with a hand-built flow, whose branches are BRANCH nodes of that flow.
   *
   * @generated from field: repeated tracker.v1.CampaignBranch branches = 30;
   */
  branches: CampaignBranch[] = [];

  /**
   * The campaign's group (decision 04: a field; tags stay beside it). ""
   * = none. ListCampaignGroups names them.
   *
   * @generated from field: string group_id = 32;
   */
  groupId = "";

  /**
   * The managed campaign's buyer flow rules (decision 06), checked top to
   * bottom before the weighted rotation; the first that matches sends the
   * visitor to its target, the rest go by the weights. Compiled into the
   * generated flow on every save. Refused on a hand-built flow — its graph
   * owns its conditions (the admin's flow editor).
   *
   * @generated from field: repeated tracker.v1.CampaignRule rules = 33;
   */
  rules: CampaignRule[] = [];

  /**
   * The managed campaign's re-entries: a visit that comes back to the
   * campaign's own path carrying param_name=param_value goes into the named
   * branch instead of the rotation (a page's back button or next-step button
   * re-opening the ad link). Checked after the rules — a visit a rule sends
   * elsewhere is not let in. The branch must be one of `branches`.
   *
   * @generated from field: repeated tracker.v1.CampaignReentry reentries = 34;
   */
  reentries: CampaignReentry[] = [];

  /**
   * The managed campaign's offer pin: a visit whose query parameter
   * param_name carries one of `values` is routed to that offer wherever the
   * flow splits between offers. Unset = none.
   *
   * @generated from field: tracker.v1.CampaignOfferPin offer_pin = 35;
   */
  offerPin?: CampaignOfferPin;

  /**
   * The managed campaign's thank-you page: a THANK_YOU lander its leads land
   * on when the landing ships no thankyou.html of its own. "" = the
   * workspace's default thank-you lander for the visitor. Compiled into the
   * generated flow as a LANDER node role=thankyou; refused on a hand-built
   * flow, whose thank-you nodes are its graph's.
   *
   * @generated from field: string thank_you_lander_id = 36;
   */
  thankYouLanderId = "";

  /**
   * Output only. Set on a campaign another block copied in through
   * tracker.imports.v1: the source's on-screen label and where the campaign
   * is managed. While `locked`, every edit here is refused
   * (FailedPrecondition, reason locked_by_source) — the source is where it
   * changes.
   *
   * @generated from field: tracker.v1.CampaignImport imported_from = 37;
   */
  importedFrom?: CampaignImport;

  constructor(data?: PartialMessage<Campaign>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Campaign";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "traffic_source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "flow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tracking_domain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "status", kind: "enum", T: proto3.getEnumType(CampaignStatus) },
    { no: 9, name: "cost_model", kind: "enum", T: proto3.getEnumType(CostModel) },
    { no: 10, name: "default_cost", kind: "message", T: Money },
    { no: 11, name: "schedule", kind: "message", T: CampaignSchedule },
    { no: 12, name: "additional_context", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 13, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "tags", kind: "message", T: TagRef, repeated: true },
    { no: 15, name: "ownership", kind: "message", T: Ownership },
    { no: 16, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "revision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 19, name: "public_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "flow_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "offer_weights", kind: "message", T: OfferWeight, repeated: true },
    { no: 25, name: "lander_weights", kind: "message", T: LanderWeight, repeated: true },
    { no: 26, name: "template_bindings", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 29, name: "platform_params", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 30, name: "branches", kind: "message", T: CampaignBranch, repeated: true },
    { no: 32, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "rules", kind: "message", T: CampaignRule, repeated: true },
    { no: 34, name: "reentries", kind: "message", T: CampaignReentry, repeated: true },
    { no: 35, name: "offer_pin", kind: "message", T: CampaignOfferPin },
    { no: 36, name: "thank_you_lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "imported_from", kind: "message", T: CampaignImport },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Campaign {
    return new Campaign().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Campaign {
    return new Campaign().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Campaign {
    return new Campaign().fromJsonString(jsonString, options);
  }

  static equals(a: Campaign | PlainMessage<Campaign> | undefined, b: Campaign | PlainMessage<Campaign> | undefined): boolean {
    return proto3.util.equals(Campaign, a, b);
  }
}

/**
 * Where an imported campaign came from — data, never a system the tracker
 * knows (a label and a link).
 *
 * @generated from message tracker.v1.CampaignImport
 */
export class CampaignImport extends Message<CampaignImport> {
  /**
   * @generated from field: string source_id = 1;
   */
  sourceId = "";

  /**
   * @generated from field: string label = 2;
   */
  label = "";

  /**
   * @generated from field: string manage_url = 3;
   */
  manageUrl = "";

  /**
   * @generated from field: bool locked = 4;
   */
  locked = false;

  constructor(data?: PartialMessage<CampaignImport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignImport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "manage_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "locked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignImport {
    return new CampaignImport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignImport {
    return new CampaignImport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignImport {
    return new CampaignImport().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignImport | PlainMessage<CampaignImport> | undefined, b: CampaignImport | PlainMessage<CampaignImport> | undefined): boolean {
    return proto3.util.equals(CampaignImport, a, b);
  }
}

/**
 * @generated from message tracker.v1.CampaignReentry
 */
export class CampaignReentry extends Message<CampaignReentry> {
  /**
   * @generated from field: string param_name = 1;
   */
  paramName = "";

  /**
   * @generated from field: string param_value = 2;
   */
  paramValue = "";

  /**
   * @generated from field: tracker.v1.BranchTrigger branch = 3;
   */
  branch = BranchTrigger.UNSPECIFIED;

  constructor(data?: PartialMessage<CampaignReentry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignReentry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "param_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "param_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "branch", kind: "enum", T: proto3.getEnumType(BranchTrigger) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignReentry {
    return new CampaignReentry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignReentry {
    return new CampaignReentry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignReentry {
    return new CampaignReentry().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignReentry | PlainMessage<CampaignReentry> | undefined, b: CampaignReentry | PlainMessage<CampaignReentry> | undefined): boolean {
    return proto3.util.equals(CampaignReentry, a, b);
  }
}

/**
 * @generated from message tracker.v1.CampaignOfferPin
 */
export class CampaignOfferPin extends Message<CampaignOfferPin> {
  /**
   * @generated from field: string param_name = 1;
   */
  paramName = "";

  /**
   * Parameter value → the id of one of the campaign's offers (offer_weights,
   * a branch's or a rule's). The values are whatever the sending page writes.
   *
   * @generated from field: map<string, string> values = 2;
   */
  values: { [key: string]: string } = {};

  constructor(data?: PartialMessage<CampaignOfferPin>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignOfferPin";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "param_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "values", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignOfferPin {
    return new CampaignOfferPin().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignOfferPin {
    return new CampaignOfferPin().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignOfferPin {
    return new CampaignOfferPin().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignOfferPin | PlainMessage<CampaignOfferPin> | undefined, b: CampaignOfferPin | PlainMessage<CampaignOfferPin> | undefined): boolean {
    return proto3.util.equals(CampaignOfferPin, a, b);
  }
}

/**
 * One buyer flow rule: if match, send the visitor to exactly one target —
 * an offer, a landing page, or a URL (a neutral / white page).
 *
 * @generated from message tracker.v1.CampaignRule
 */
export class CampaignRule extends Message<CampaignRule> {
  /**
   * @generated from field: tracker.v1.CampaignRuleMatch match = 1;
   */
  match = CampaignRuleMatch.UNSPECIFIED;

  /**
   * COUNTRY_*: ISO codes; DEVICE: classes; FIELD: what op compares with
   * (addresses / CIDR ranges for ip, patterns for regex; none for present /
   * not_present).
   *
   * @generated from field: repeated string values = 2;
   */
  values: string[] = [];

  /**
   * SCHEDULE: hours of the workspace's day, [hour_from, hour_to); from > to
   * wraps past midnight; from == to = the whole day.
   *
   * @generated from field: uint32 hour_from = 3;
   */
  hourFrom = 0;

  /**
   * @generated from field: uint32 hour_to = 4;
   */
  hourTo = 0;

  /**
   * SCHEDULE: 1 = Monday … 7 = Sunday; empty = every day.
   *
   * @generated from field: repeated uint32 weekdays = 5;
   */
  weekdays: number[] = [];

  /**
   * @generated from field: string offer_id = 6;
   */
  offerId = "";

  /**
   * @generated from field: string lander_id = 7;
   */
  landerId = "";

  /**
   * @generated from field: string url = 8;
   */
  url = "";

  /**
   * PARAM_NOT_EQUAL: the parameter and the value the link must carry.
   *
   * @generated from field: string param_name = 9;
   */
  paramName = "";

  /**
   * @generated from field: string param_value = 10;
   */
  paramValue = "";

  /**
   * Output only: the flow node the rule sends a visit to — the «node»
   * dimension's value for the visits this rule took (the card's «Поток»).
   * "" on a campaign that is not managed. Ignored on write.
   *
   * @generated from field: string node_id = 11;
   */
  nodeId = "";

  /**
   * FIELD: the field of the visit and the op (FieldMatch).
   *
   * @generated from field: string field = 12;
   */
  field = "";

  /**
   * @generated from field: string op = 13;
   */
  op = "";

  constructor(data?: PartialMessage<CampaignRule>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignRule";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "match", kind: "enum", T: proto3.getEnumType(CampaignRuleMatch) },
    { no: 2, name: "values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "hour_from", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "hour_to", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "weekdays", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 6, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "param_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "param_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "op", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignRule {
    return new CampaignRule().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignRule {
    return new CampaignRule().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignRule {
    return new CampaignRule().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignRule | PlainMessage<CampaignRule> | undefined, b: CampaignRule | PlainMessage<CampaignRule> | undefined): boolean {
    return proto3.util.equals(CampaignRule, a, b);
  }
}

/**
 * One managed monetisation branch — the Keitaro BackButton stream's shape: its
 * own landing(s) and/or other offers, each weighted. Landers without offers
 * re-enter the campaign's own offer rotation; offers without landers send the
 * visitor straight to an offer.
 *
 * @generated from message tracker.v1.CampaignBranch
 */
export class CampaignBranch extends Message<CampaignBranch> {
  /**
   * @generated from field: tracker.v1.BranchTrigger trigger = 1;
   */
  trigger = BranchTrigger.UNSPECIFIED;

  /**
   * Seconds without input before an IDLE branch fires (5..600). Ignored otherwise.
   *
   * @generated from field: uint32 idle_seconds = 2;
   */
  idleSeconds = 0;

  /**
   * @generated from field: repeated tracker.v1.LanderWeight lander_weights = 3;
   */
  landerWeights: LanderWeight[] = [];

  /**
   * @generated from field: repeated tracker.v1.OfferWeight offer_weights = 4;
   */
  offerWeights: OfferWeight[] = [];

  constructor(data?: PartialMessage<CampaignBranch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignBranch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trigger", kind: "enum", T: proto3.getEnumType(BranchTrigger) },
    { no: 2, name: "idle_seconds", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "lander_weights", kind: "message", T: LanderWeight, repeated: true },
    { no: 4, name: "offer_weights", kind: "message", T: OfferWeight, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignBranch {
    return new CampaignBranch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignBranch {
    return new CampaignBranch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignBranch {
    return new CampaignBranch().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignBranch | PlainMessage<CampaignBranch> | undefined, b: CampaignBranch | PlainMessage<CampaignBranch> | undefined): boolean {
    return proto3.util.equals(CampaignBranch, a, b);
  }
}

/**
 * One picked pool entry with its relative rotation weight (60/40 and 3/2 encode
 * the same split). Expanded into the template's OFFER_POOL / LANDER_POOL.
 *
 * @generated from message tracker.v1.OfferWeight
 */
export class OfferWeight extends Message<OfferWeight> {
  /**
   * @generated from field: string offer_id = 1;
   */
  offerId = "";

  /**
   * @generated from field: uint32 weight = 2;
   */
  weight = 0;

  constructor(data?: PartialMessage<OfferWeight>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.OfferWeight";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "weight", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OfferWeight {
    return new OfferWeight().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OfferWeight {
    return new OfferWeight().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OfferWeight {
    return new OfferWeight().fromJsonString(jsonString, options);
  }

  static equals(a: OfferWeight | PlainMessage<OfferWeight> | undefined, b: OfferWeight | PlainMessage<OfferWeight> | undefined): boolean {
    return proto3.util.equals(OfferWeight, a, b);
  }
}

/**
 * @generated from message tracker.v1.LanderWeight
 */
export class LanderWeight extends Message<LanderWeight> {
  /**
   * @generated from field: string lander_id = 1;
   */
  landerId = "";

  /**
   * @generated from field: uint32 weight = 2;
   */
  weight = 0;

  constructor(data?: PartialMessage<LanderWeight>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.LanderWeight";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "weight", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LanderWeight {
    return new LanderWeight().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LanderWeight {
    return new LanderWeight().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LanderWeight {
    return new LanderWeight().fromJsonString(jsonString, options);
  }

  static equals(a: LanderWeight | PlainMessage<LanderWeight> | undefined, b: LanderWeight | PlainMessage<LanderWeight> | undefined): boolean {
    return proto3.util.equals(LanderWeight, a, b);
  }
}

/**
 * @generated from message tracker.v1.CampaignSchedule
 */
export class CampaignSchedule extends Message<CampaignSchedule> {
  /**
   * ISO 8601, optional
   *
   * @generated from field: string starts_at = 1;
   */
  startsAt = "";

  /**
   * @generated from field: string ends_at = 2;
   */
  endsAt = "";

  /**
   * @generated from field: string timezone = 3;
   */
  timezone = "";

  constructor(data?: PartialMessage<CampaignSchedule>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignSchedule";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "starts_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ends_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignSchedule {
    return new CampaignSchedule().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignSchedule {
    return new CampaignSchedule().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignSchedule {
    return new CampaignSchedule().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignSchedule | PlainMessage<CampaignSchedule> | undefined, b: CampaignSchedule | PlainMessage<CampaignSchedule> | undefined): boolean {
    return proto3.util.equals(CampaignSchedule, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCampaignsRequest
 */
export class ListCampaignsRequest extends Message<ListCampaignsRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: repeated tracker.v1.CampaignStatus statuses = 2;
   */
  statuses: CampaignStatus[] = [];

  /**
   * @generated from field: string search = 4;
   */
  search = "";

  /**
   * @generated from field: repeated string tag_ids = 5;
   */
  tagIds: string[] = [];

  /**
   * when set, each item carries stats over it
   *
   * @generated from field: tracker.v1.DateRange stats_range = 6;
   */
  statsRange?: DateRange;

  /**
   * The picker filters a launcher narrows campaigns by ("связка" choice in the
   * cabinet): which offer the campaign routes to, which geo, whose it is.
   * Every list is OR within itself and AND across lists; empty = no filter.
   *
   * Offers the flow routes to, by tracker offer id ...
   *
   * @generated from field: repeated string offer_ids = 7;
   */
  offerIds: string[] = [];

  /**
   * ... or by the offer's id at its offer source (offers.source_ref — for
   * the backoffice, its offer UUID). A caller that masters offers elsewhere
   * never has to learn the tracker's ids.
   *
   * @generated from field: repeated string offer_source_refs = 8;
   */
  offerSourceRefs: string[] = [];

  /**
   * ISO-3166 alpha-2 codes, matched against the countries of those offers.
   *
   * @generated from field: repeated string countries = 9;
   */
  countries: string[] = [];

  /**
   * Keycloak subs of the campaigns' owners ("Мои" = the caller's own sub).
   *
   * @generated from field: repeated string owner_ids = 10;
   */
  ownerIds: string[] = [];

  /**
   * A Keycloak sub. When set, the response says how many domains of that
   * person's own the domain provider holds that can take a campaign
   * (ListCampaignsResponse.free_domains): the domains a copy made for them
   * takes its address from. One provider call per request.
   *
   * @generated from field: string free_domains_of = 11;
   */
  freeDomainsOf = "";

  /**
   * Campaigns by their own id — a launcher reading back the one campaign a
   * buyer picked, with its offers, landers and languages. ANDed like the rest.
   *
   * @generated from field: repeated string ids = 12;
   */
  ids: string[] = [];

  /**
   * Campaigns in these groups; "none" = campaigns in no group.
   *
   * @generated from field: repeated string group_ids = 13;
   */
  groupIds: string[] = [];

  /**
   * Conditions on the period's metrics (needs stats_range): «ROI < 0,
   * расход > 150». ANDed; a blank metric never passes. Applied before paging.
   *
   * @generated from field: repeated tracker.v1.MetricFilter metric_filters = 14;
   */
  metricFilters: MetricFilter[] = [];

  /**
   * Sort before paging, over every matching campaign: a metric key of the
   * reporting schema (needs stats_range), or "name" / "created_at".
   * Empty = newest first.
   *
   * @generated from field: tracker.v1.StatsSortOptions sort = 15;
   */
  sort?: StatsSortOptions;

  /**
   * The period to compare with: each item carries compare_stats.
   *
   * @generated from field: tracker.v1.DateRange compare_range = 16;
   */
  compareRange?: DateRange;

  /**
   * The list's folding (board CampGroups: По группам | По офферам | По
   * баерам, and по источникам): "" | group | offer | owner | source. With
   * stats_range the response carries each fold's numbers in group_totals,
   * counted by the server over the campaigns that passed — people are
   * uniques of the fold, never a sum of its rows.
   *
   * @generated from field: string group_by = 17;
   */
  groupBy = "";

  /**
   * Traffic sources by id (OR), ANDed with the rest. Empty = any source.
   *
   * @generated from field: repeated string traffic_source_ids = 18;
   */
  trafficSourceIds: string[] = [];

  /**
   * A quick view of the list (board CampList: Сливают · Нет кликов · Холд >
   * 50%), decided by the server over stats_range (needs it), ANDed with the
   * rest. The words of CampaignListItem.flags.
   *
   * @generated from field: string quick = 19;
   */
  quick = "";

  constructor(data?: PartialMessage<ListCampaignsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCampaignsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "statuses", kind: "enum", T: proto3.getEnumType(CampaignStatus), repeated: true },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "stats_range", kind: "message", T: DateRange },
    { no: 7, name: "offer_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "offer_source_refs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "owner_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "free_domains_of", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "group_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 14, name: "metric_filters", kind: "message", T: MetricFilter, repeated: true },
    { no: 15, name: "sort", kind: "message", T: StatsSortOptions },
    { no: 16, name: "compare_range", kind: "message", T: DateRange },
    { no: 17, name: "group_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "traffic_source_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 19, name: "quick", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCampaignsRequest {
    return new ListCampaignsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCampaignsRequest {
    return new ListCampaignsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCampaignsRequest {
    return new ListCampaignsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCampaignsRequest | PlainMessage<ListCampaignsRequest> | undefined, b: ListCampaignsRequest | PlainMessage<ListCampaignsRequest> | undefined): boolean {
    return proto3.util.equals(ListCampaignsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CampaignListItem
 */
export class CampaignListItem extends Message<CampaignListItem> {
  /**
   * @generated from field: tracker.v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  /**
   * Eagerly-joined display fields (saves a round trip on the list page).
   *
   * @generated from field: string traffic_source_name = 2;
   */
  trafficSourceName = "";

  /**
   * @generated from field: string flow_name = 3;
   */
  flowName = "";

  /**
   * The campaign's tracking domain, "" when it has none, and whether the edge
   * serves it (active + bound) — a launcher must not hand out a link on a
   * domain that does not answer yet.
   *
   * @generated from field: string fqdn = 5;
   */
  fqdn = "";

  /**
   * @generated from field: bool domain_serves = 6;
   */
  domainServes = false;

  /**
   * Every offer the campaign's flow routes to, with the countries they carry.
   *
   * @generated from field: repeated tracker.v1.CampaignOffer offers = 7;
   */
  offers: CampaignOffer[] = [];

  /**
   * The union of those offers' countries, sorted.
   *
   * @generated from field: repeated string countries = 8;
   */
  countries: string[] = [];

  /**
   * The languages of the pages an ad click lands on (landers[].language),
   * lower-case, sorted, without blanks — what a launcher targets the ad's
   * language by. Empty when no entry lander names its language.
   *
   * @generated from field: repeated string languages = 10;
   */
  languages: string[] = [];

  /**
   * The pages an ad click lands on — the flow's enabled entry landers (no
   * thank-you page, no monetisation branch), in flow order, with their
   * rotation weights.
   *
   * @generated from field: repeated tracker.v1.CampaignLander landers = 11;
   */
  landers: CampaignLander[] = [];

  /**
   * Every metric of the reporting schema (workspace formulas included) over
   * stats_range, from the one reader every screen uses.
   *
   * @generated from field: tracker.v1.StatsRow stats = 12;
   */
  stats?: StatsRow;

  /**
   * The same over compare_range.
   *
   * @generated from field: tracker.v1.StatsRow compare_stats = 13;
   */
  compareStats?: StatsRow;

  /**
   * The owner as the tracker last saw them sign in («По баерам»): name, else
   * email, else "".
   *
   * @generated from field: string owner_name = 14;
   */
  ownerName = "";

  /**
   * The campaign's group, "" when none.
   *
   * @generated from field: string group_name = 15;
   */
  groupName = "";

  /**
   * What the server says of the campaign over stats_range — the row's
   * badges and the quick views: "losing" (spent and lost: cost > 0, profit
   * < 0), "no_clicks" (active, no visit in the period), "hold_over_half"
   * (more than half its leads still in hold). Empty without stats_range.
   *
   * @generated from field: repeated string flags = 16;
   */
  flags: string[] = [];

  constructor(data?: PartialMessage<CampaignListItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignListItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign", kind: "message", T: Campaign },
    { no: 2, name: "traffic_source_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "flow_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "fqdn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "domain_serves", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "offers", kind: "message", T: CampaignOffer, repeated: true },
    { no: 8, name: "countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "languages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "landers", kind: "message", T: CampaignLander, repeated: true },
    { no: 12, name: "stats", kind: "message", T: StatsRow },
    { no: 13, name: "compare_stats", kind: "message", T: StatsRow },
    { no: 14, name: "owner_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "flags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignListItem {
    return new CampaignListItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignListItem {
    return new CampaignListItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignListItem {
    return new CampaignListItem().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignListItem | PlainMessage<CampaignListItem> | undefined, b: CampaignListItem | PlainMessage<CampaignListItem> | undefined): boolean {
    return proto3.util.equals(CampaignListItem, a, b);
  }
}

/**
 * One page an ad click on a campaign can land on, as a launcher shows it
 * ("doctor-v4 70%, quiz-v2 30%").
 *
 * @generated from message tracker.v1.CampaignLander
 */
export class CampaignLander extends Message<CampaignLander> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * The lander's language as the tracker holds it ("" = not named).
   *
   * @generated from field: string language = 3;
   */
  language = "";

  /**
   * prelander | landing — where in the funnel the page sits.
   *
   * @generated from field: string role = 4;
   */
  role = "";

  /**
   * The relative rotation weight of the lander's flow nodes (summed when one
   * lander sits on several nodes).
   *
   * @generated from field: int32 weight = 5;
   */
  weight = 0;

  /**
   * weight as a share of all entry landers of the same role, 0-100, rounded.
   *
   * @generated from field: int32 percent = 6;
   */
  percent = 0;

  constructor(data?: PartialMessage<CampaignLander>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignLander";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "weight", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "percent", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignLander {
    return new CampaignLander().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignLander {
    return new CampaignLander().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignLander {
    return new CampaignLander().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignLander | PlainMessage<CampaignLander> | undefined, b: CampaignLander | PlainMessage<CampaignLander> | undefined): boolean {
    return proto3.util.equals(CampaignLander, a, b);
  }
}

/**
 * One offer a campaign routes to, as a launcher shows it.
 *
 * @generated from message tracker.v1.CampaignOffer
 */
export class CampaignOffer extends Message<CampaignOffer> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * The offer source that publishes it ("" for a tracker-authored offer) and
   * its id there.
   *
   * @generated from field: string source = 3;
   */
  source = "";

  /**
   * @generated from field: string source_ref = 4;
   */
  sourceRef = "";

  /**
   * @generated from field: repeated string countries = 5;
   */
  countries: string[] = [];

  constructor(data?: PartialMessage<CampaignOffer>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignOffer";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignOffer {
    return new CampaignOffer().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignOffer {
    return new CampaignOffer().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignOffer {
    return new CampaignOffer().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignOffer | PlainMessage<CampaignOffer> | undefined, b: CampaignOffer | PlainMessage<CampaignOffer> | undefined): boolean {
    return proto3.util.equals(CampaignOffer, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCampaignsResponse
 */
export class ListCampaignsResponse extends Message<ListCampaignsResponse> {
  /**
   * @generated from field: repeated tracker.v1.CampaignListItem items = 1;
   */
  items: CampaignListItem[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  /**
   * «Итого» of every matching campaign (not only the page), counted once by
   * the server — people are uniques of the whole, never a sum of rows. Set
   * with stats_range.
   *
   * @generated from field: tracker.v1.StatsRow totals = 4;
   */
  totals?: StatsRow;

  /**
   * @generated from field: tracker.v1.StatsRow compare_totals = 5;
   */
  compareTotals?: StatsRow;

  /**
   * One per fold of ListCampaignsRequest.group_by, in no particular order.
   *
   * @generated from field: repeated tracker.v1.CampaignGroupTotal group_totals = 6;
   */
  groupTotals: CampaignGroupTotal[] = [];

  /**
   * How many campaigns each quick view would show, over the campaigns that
   * passed the catalog filters (statuses, owners, sources, groups, geo,
   * offers, search) — before the quick view and the metric conditions, so
   * the counts stay put while a condition is tried. Set with stats_range.
   *
   * @generated from field: tracker.v1.CampaignQuickCounts quick_counts = 7;
   */
  quickCounts?: CampaignQuickCounts;

  /**
   * Domains of ListCampaignsRequest.free_domains_of: active at the domain
   * provider, owned by that person, able to take a campaign (attached or not
   * — one domain carries many campaigns under their own paths). -1 when the
   * request did not ask, or the domain provider keeps no owners.
   *
   * @generated from field: int32 free_domains = 3;
   */
  freeDomains = 0;

  constructor(data?: PartialMessage<ListCampaignsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCampaignsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: CampaignListItem, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
    { no: 4, name: "totals", kind: "message", T: StatsRow },
    { no: 5, name: "compare_totals", kind: "message", T: StatsRow },
    { no: 6, name: "group_totals", kind: "message", T: CampaignGroupTotal, repeated: true },
    { no: 7, name: "quick_counts", kind: "message", T: CampaignQuickCounts },
    { no: 3, name: "free_domains", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCampaignsResponse {
    return new ListCampaignsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCampaignsResponse {
    return new ListCampaignsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCampaignsResponse {
    return new ListCampaignsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCampaignsResponse | PlainMessage<ListCampaignsResponse> | undefined, b: ListCampaignsResponse | PlainMessage<ListCampaignsResponse> | undefined): boolean {
    return proto3.util.equals(ListCampaignsResponse, a, b);
  }
}

/**
 * CampaignQuickCounts are the numbers beside the list's quick views.
 *
 * @generated from message tracker.v1.CampaignQuickCounts
 */
export class CampaignQuickCounts extends Message<CampaignQuickCounts> {
  /**
   * Every campaign that passed the catalog filters («Активные»).
   *
   * @generated from field: int32 all = 1;
   */
  all = 0;

  /**
   * @generated from field: int32 losing = 2;
   */
  losing = 0;

  /**
   * @generated from field: int32 no_clicks = 3;
   */
  noClicks = 0;

  /**
   * @generated from field: int32 hold_over_half = 4;
   */
  holdOverHalf = 0;

  constructor(data?: PartialMessage<CampaignQuickCounts>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignQuickCounts";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "all", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "losing", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "no_clicks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "hold_over_half", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignQuickCounts {
    return new CampaignQuickCounts().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignQuickCounts {
    return new CampaignQuickCounts().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignQuickCounts {
    return new CampaignQuickCounts().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignQuickCounts | PlainMessage<CampaignQuickCounts> | undefined, b: CampaignQuickCounts | PlainMessage<CampaignQuickCounts> | undefined): boolean {
    return proto3.util.equals(CampaignQuickCounts, a, b);
  }
}

/**
 * CampaignGroupTotal is a fold's header line on the campaign list.
 *
 * @generated from message tracker.v1.CampaignGroupTotal
 */
export class CampaignGroupTotal extends Message<CampaignGroupTotal> {
  /**
   * The fold's value as the matching report dimension carries it: a group,
   * offer or traffic source id, an owner's Keycloak sub; "" = без группы /
   * без баера / без источника, and for «offer» the visits that reached no
   * offer.
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * How many of the matching campaigns fall in it. By offer a campaign falls
   * in every offer its flow routes to.
   *
   * @generated from field: int32 campaigns = 2;
   */
  campaigns = 0;

  /**
   * The fold over stats_range, counted once by the server — the same engine
   * as totals (a report grouped by the dimension over these campaigns).
   *
   * @generated from field: tracker.v1.StatsRow stats = 3;
   */
  stats?: StatsRow;

  /**
   * @generated from field: tracker.v1.StatsRow compare_stats = 4;
   */
  compareStats?: StatsRow;

  constructor(data?: PartialMessage<CampaignGroupTotal>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignGroupTotal";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "campaigns", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "stats", kind: "message", T: StatsRow },
    { no: 4, name: "compare_stats", kind: "message", T: StatsRow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignGroupTotal {
    return new CampaignGroupTotal().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignGroupTotal {
    return new CampaignGroupTotal().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignGroupTotal {
    return new CampaignGroupTotal().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignGroupTotal | PlainMessage<CampaignGroupTotal> | undefined, b: CampaignGroupTotal | PlainMessage<CampaignGroupTotal> | undefined): boolean {
    return proto3.util.equals(CampaignGroupTotal, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetCampaignRequest
 */
export class GetCampaignRequest extends Message<GetCampaignRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetCampaignRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetCampaignRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCampaignRequest {
    return new GetCampaignRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCampaignRequest {
    return new GetCampaignRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCampaignRequest {
    return new GetCampaignRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCampaignRequest | PlainMessage<GetCampaignRequest> | undefined, b: GetCampaignRequest | PlainMessage<GetCampaignRequest> | undefined): boolean {
    return proto3.util.equals(GetCampaignRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetCampaignResponse
 */
export class GetCampaignResponse extends Message<GetCampaignResponse> {
  /**
   * @generated from field: tracker.v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  constructor(data?: PartialMessage<GetCampaignResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetCampaignResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign", kind: "message", T: Campaign },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCampaignResponse {
    return new GetCampaignResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCampaignResponse {
    return new GetCampaignResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCampaignResponse {
    return new GetCampaignResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCampaignResponse | PlainMessage<GetCampaignResponse> | undefined, b: GetCampaignResponse | PlainMessage<GetCampaignResponse> | undefined): boolean {
    return proto3.util.equals(GetCampaignResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateCampaignRequest
 */
export class CreateCampaignRequest extends Message<CreateCampaignRequest> {
  /**
   * @generated from field: tracker.v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  /**
   * One of the owner's own domains (ListFreeDomains) to serve the campaign
   * on, as the person picked it: the workspace's tracking domain of that name
   * when it has one (other campaigns may already live there), else bound now;
   * set as the campaign's tracking_domain_id, exactly as CloneCampaign takes
   * one. The campaign's public_path must be free on it among every live
   * campaign there (imported copies — Keitaro's aliases — included): a clash
   * is a field error on public_path. Not his, or unable to take a campaign: a
   * field error on take_fqdn. "" = keep campaign.tracking_domain_id as given.
   *
   * @generated from field: string take_fqdn = 2;
   */
  takeFqdn = "";

  /**
   * Keycloak sub of the buyer the campaign is made FOR: its owner, and the
   * person whose own domain take_fqdn names. Empty = the caller. Naming
   * somebody else takes workspace-wide visibility (tracker-admin) — the
   * cabinet's service account creating a связка for a buyer from its wizard,
   * exactly as CloneCampaign.owner_id makes a copy for one.
   *
   * @generated from field: string owner_id = 3;
   */
  ownerId = "";

  /**
   * A white from the org's white pool (white_pool.proto): with auto the
   * campaign takes the freshest white of its category × geo × language in
   * the same transaction and its BOT / COUNTRY_NOT_IN rules point at it; an
   * empty cell leaves it PENDING (ActivateCampaign refuses white_pending)
   * and orders one at once. Unset = no pool white.
   *
   * @generated from field: tracker.v1.WhiteAssignment white = 4;
   */
  white?: WhiteAssignment;

  constructor(data?: PartialMessage<CreateCampaignRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateCampaignRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign", kind: "message", T: Campaign },
    { no: 2, name: "take_fqdn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "white", kind: "message", T: WhiteAssignment },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCampaignRequest {
    return new CreateCampaignRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCampaignRequest {
    return new CreateCampaignRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCampaignRequest {
    return new CreateCampaignRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCampaignRequest | PlainMessage<CreateCampaignRequest> | undefined, b: CreateCampaignRequest | PlainMessage<CreateCampaignRequest> | undefined): boolean {
    return proto3.util.equals(CreateCampaignRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateCampaignResponse
 */
export class CreateCampaignResponse extends Message<CreateCampaignResponse> {
  /**
   * @generated from field: tracker.v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  /**
   * The campaign's white; state NONE when none was asked for.
   *
   * @generated from field: tracker.v1.CampaignWhite white = 2;
   */
  white?: CampaignWhite;

  constructor(data?: PartialMessage<CreateCampaignResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateCampaignResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign", kind: "message", T: Campaign },
    { no: 2, name: "white", kind: "message", T: CampaignWhite },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCampaignResponse {
    return new CreateCampaignResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCampaignResponse {
    return new CreateCampaignResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCampaignResponse {
    return new CreateCampaignResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCampaignResponse | PlainMessage<CreateCampaignResponse> | undefined, b: CreateCampaignResponse | PlainMessage<CreateCampaignResponse> | undefined): boolean {
    return proto3.util.equals(CreateCampaignResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateCampaignRequest
 */
export class UpdateCampaignRequest extends Message<UpdateCampaignRequest> {
  /**
   * @generated from field: tracker.v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  /**
   * @generated from field: int64 expected_revision = 2;
   */
  expectedRevision = protoInt64.zero;

  /**
   * As on CreateCampaignRequest: move the campaign onto this domain of its
   * owner. The previous domain stays bound (other campaigns may use it).
   *
   * @generated from field: string take_fqdn = 3;
   */
  takeFqdn = "";

  constructor(data?: PartialMessage<UpdateCampaignRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateCampaignRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign", kind: "message", T: Campaign },
    { no: 2, name: "expected_revision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "take_fqdn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCampaignRequest {
    return new UpdateCampaignRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCampaignRequest {
    return new UpdateCampaignRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCampaignRequest {
    return new UpdateCampaignRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCampaignRequest | PlainMessage<UpdateCampaignRequest> | undefined, b: UpdateCampaignRequest | PlainMessage<UpdateCampaignRequest> | undefined): boolean {
    return proto3.util.equals(UpdateCampaignRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateCampaignResponse
 */
export class UpdateCampaignResponse extends Message<UpdateCampaignResponse> {
  /**
   * @generated from field: tracker.v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  constructor(data?: PartialMessage<UpdateCampaignResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateCampaignResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign", kind: "message", T: Campaign },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCampaignResponse {
    return new UpdateCampaignResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCampaignResponse {
    return new UpdateCampaignResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCampaignResponse {
    return new UpdateCampaignResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCampaignResponse | PlainMessage<UpdateCampaignResponse> | undefined, b: UpdateCampaignResponse | PlainMessage<UpdateCampaignResponse> | undefined): boolean {
    return proto3.util.equals(UpdateCampaignResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.PauseCampaignRequest
 */
export class PauseCampaignRequest extends Message<PauseCampaignRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<PauseCampaignRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PauseCampaignRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PauseCampaignRequest {
    return new PauseCampaignRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PauseCampaignRequest {
    return new PauseCampaignRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PauseCampaignRequest {
    return new PauseCampaignRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PauseCampaignRequest | PlainMessage<PauseCampaignRequest> | undefined, b: PauseCampaignRequest | PlainMessage<PauseCampaignRequest> | undefined): boolean {
    return proto3.util.equals(PauseCampaignRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.PauseCampaignResponse
 */
export class PauseCampaignResponse extends Message<PauseCampaignResponse> {
  /**
   * @generated from field: tracker.v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  constructor(data?: PartialMessage<PauseCampaignResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PauseCampaignResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign", kind: "message", T: Campaign },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PauseCampaignResponse {
    return new PauseCampaignResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PauseCampaignResponse {
    return new PauseCampaignResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PauseCampaignResponse {
    return new PauseCampaignResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PauseCampaignResponse | PlainMessage<PauseCampaignResponse> | undefined, b: PauseCampaignResponse | PlainMessage<PauseCampaignResponse> | undefined): boolean {
    return proto3.util.equals(PauseCampaignResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ActivateCampaignRequest
 */
export class ActivateCampaignRequest extends Message<ActivateCampaignRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ActivateCampaignRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ActivateCampaignRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateCampaignRequest {
    return new ActivateCampaignRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateCampaignRequest {
    return new ActivateCampaignRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateCampaignRequest {
    return new ActivateCampaignRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateCampaignRequest | PlainMessage<ActivateCampaignRequest> | undefined, b: ActivateCampaignRequest | PlainMessage<ActivateCampaignRequest> | undefined): boolean {
    return proto3.util.equals(ActivateCampaignRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ActivateCampaignResponse
 */
export class ActivateCampaignResponse extends Message<ActivateCampaignResponse> {
  /**
   * @generated from field: tracker.v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  constructor(data?: PartialMessage<ActivateCampaignResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ActivateCampaignResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign", kind: "message", T: Campaign },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateCampaignResponse {
    return new ActivateCampaignResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateCampaignResponse {
    return new ActivateCampaignResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateCampaignResponse {
    return new ActivateCampaignResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateCampaignResponse | PlainMessage<ActivateCampaignResponse> | undefined, b: ActivateCampaignResponse | PlainMessage<ActivateCampaignResponse> | undefined): boolean {
    return proto3.util.equals(ActivateCampaignResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveCampaignRequest
 */
export class ArchiveCampaignRequest extends Message<ArchiveCampaignRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ArchiveCampaignRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveCampaignRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveCampaignRequest {
    return new ArchiveCampaignRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveCampaignRequest {
    return new ArchiveCampaignRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveCampaignRequest {
    return new ArchiveCampaignRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveCampaignRequest | PlainMessage<ArchiveCampaignRequest> | undefined, b: ArchiveCampaignRequest | PlainMessage<ArchiveCampaignRequest> | undefined): boolean {
    return proto3.util.equals(ArchiveCampaignRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveCampaignResponse
 */
export class ArchiveCampaignResponse extends Message<ArchiveCampaignResponse> {
  constructor(data?: PartialMessage<ArchiveCampaignResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveCampaignResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveCampaignResponse {
    return new ArchiveCampaignResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveCampaignResponse {
    return new ArchiveCampaignResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveCampaignResponse {
    return new ArchiveCampaignResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveCampaignResponse | PlainMessage<ArchiveCampaignResponse> | undefined, b: ArchiveCampaignResponse | PlainMessage<ArchiveCampaignResponse> | undefined): boolean {
    return proto3.util.equals(ArchiveCampaignResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DuplicateCampaignRequest
 */
export class DuplicateCampaignRequest extends Message<DuplicateCampaignRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string new_name = 2;
   */
  newName = "";

  constructor(data?: PartialMessage<DuplicateCampaignRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DuplicateCampaignRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DuplicateCampaignRequest {
    return new DuplicateCampaignRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DuplicateCampaignRequest {
    return new DuplicateCampaignRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DuplicateCampaignRequest {
    return new DuplicateCampaignRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DuplicateCampaignRequest | PlainMessage<DuplicateCampaignRequest> | undefined, b: DuplicateCampaignRequest | PlainMessage<DuplicateCampaignRequest> | undefined): boolean {
    return proto3.util.equals(DuplicateCampaignRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DuplicateCampaignResponse
 */
export class DuplicateCampaignResponse extends Message<DuplicateCampaignResponse> {
  /**
   * @generated from field: tracker.v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  constructor(data?: PartialMessage<DuplicateCampaignResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DuplicateCampaignResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign", kind: "message", T: Campaign },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DuplicateCampaignResponse {
    return new DuplicateCampaignResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DuplicateCampaignResponse {
    return new DuplicateCampaignResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DuplicateCampaignResponse {
    return new DuplicateCampaignResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DuplicateCampaignResponse | PlainMessage<DuplicateCampaignResponse> | undefined, b: DuplicateCampaignResponse | PlainMessage<DuplicateCampaignResponse> | undefined): boolean {
    return proto3.util.equals(DuplicateCampaignResponse, a, b);
  }
}

/**
 * CloneCampaign makes a copy of a campaign on a domain of the copy's owner —
 * every buyer has domains of his own at the domain provider: the first of
 * them that can take it in ListFreeDomains order (avoid_fqdns last), under a
 * path of its own: the same flow, offers, landers, weights and platform
 * answers under a new name, address and token.
 *
 * Idempotent on (id, clone_key): a repeat returns the clone it already made
 * and takes no second domain. A clone of an ACTIVE campaign is ACTIVE — the
 * edge starts serving it the moment its domain binds (domain_serves says
 * whether that has happened yet).
 *
 * @generated from message tracker.v1.CloneCampaignRequest
 */
export class CloneCampaignRequest extends Message<CloneCampaignRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * The caller's own key for this copy, e.g. "batch:<id>/act_<ad account>".
   *
   * @generated from field: string clone_key = 3;
   */
  cloneKey = "";

  /**
   * Keycloak sub of the buyer the copy is for: its owner, and the person
   * whose own domain it takes. Empty = the source campaign's owner.
   * Naming somebody other than yourself takes workspace-wide visibility
   * (tracker-admin) — a launcher's service account acting for a buyer.
   *
   * @generated from field: string owner_id = 4;
   */
  ownerId = "";

  /**
   * Domains of the owner the copy should rather not take — a launcher passes
   * the ones where the ad account's ads were already rejected. They go to the
   * back of the queue, not out of it: with nothing else able to take it, the
   * first of them is taken. Matched case-insensitively.
   *
   * @generated from field: repeated string avoid_fqdns = 5;
   */
  avoidFqdns: string[] = [];

  constructor(data?: PartialMessage<CloneCampaignRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CloneCampaignRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "clone_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "avoid_fqdns", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CloneCampaignRequest {
    return new CloneCampaignRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CloneCampaignRequest {
    return new CloneCampaignRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CloneCampaignRequest {
    return new CloneCampaignRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CloneCampaignRequest | PlainMessage<CloneCampaignRequest> | undefined, b: CloneCampaignRequest | PlainMessage<CloneCampaignRequest> | undefined): boolean {
    return proto3.util.equals(CloneCampaignRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CloneCampaignResponse
 */
export class CloneCampaignResponse extends Message<CloneCampaignResponse> {
  /**
   * @generated from field: tracker.v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  /**
   * @generated from field: string fqdn = 2;
   */
  fqdn = "";

  /**
   * @generated from field: bool domain_serves = 3;
   */
  domainServes = false;

  /**
   * False when the clone already existed for this clone_key.
   *
   * @generated from field: bool created = 4;
   */
  created = false;

  constructor(data?: PartialMessage<CloneCampaignResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CloneCampaignResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign", kind: "message", T: Campaign },
    { no: 2, name: "fqdn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "domain_serves", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "created", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CloneCampaignResponse {
    return new CloneCampaignResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CloneCampaignResponse {
    return new CloneCampaignResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CloneCampaignResponse {
    return new CloneCampaignResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CloneCampaignResponse | PlainMessage<CloneCampaignResponse> | undefined, b: CloneCampaignResponse | PlainMessage<CloneCampaignResponse> | undefined): boolean {
    return proto3.util.equals(CloneCampaignResponse, a, b);
  }
}

/**
 * ListFreeDomains lists EVERY domain a person owns at the domain provider
 * (owner, 03.11: a domain belongs to a person), attached or not — the
 * tracker never narrows it to "free" ones: one domain carries many campaigns
 * under their own paths, and an overlay domain lets every other request
 * through to its origin. A buyer making a связка is offered all of them and
 * picks one (CreateCampaignRequest.take_fqdn). Order: the ones the edge
 * serves now first (fewer campaigns on it first), then the rest, avoid_fqdns
 * last — the order CloneCampaign takes them in, so the first that can take a
 * campaign is the next copy's. It creates and binds nothing. (The name predates the rule;
 * it stays because the cabinet calls it.)
 *
 * @generated from message tracker.v1.ListFreeDomainsRequest
 */
export class ListFreeDomainsRequest extends Message<ListFreeDomainsRequest> {
  /**
   * Keycloak sub of the person. Empty = the caller. Naming somebody else
   * takes workspace-wide visibility, as on CloneCampaign.owner_id.
   *
   * @generated from field: string owner_id = 1;
   */
  ownerId = "";

  /**
   * At most this many; 0 = 200.
   *
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * The same avoid list a CloneCampaign would carry: those come last, so the
   * preview names the domain the copy will really take.
   *
   * @generated from field: repeated string avoid_fqdns = 3;
   */
  avoidFqdns: string[] = [];

  constructor(data?: PartialMessage<ListFreeDomainsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListFreeDomainsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "avoid_fqdns", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFreeDomainsRequest {
    return new ListFreeDomainsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFreeDomainsRequest {
    return new ListFreeDomainsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFreeDomainsRequest {
    return new ListFreeDomainsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFreeDomainsRequest | PlainMessage<ListFreeDomainsRequest> | undefined, b: ListFreeDomainsRequest | PlainMessage<ListFreeDomainsRequest> | undefined): boolean {
    return proto3.util.equals(ListFreeDomainsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListFreeDomainsResponse
 */
export class ListFreeDomainsResponse extends Message<ListFreeDomainsResponse> {
  /**
   * The domains' names, in order (one per domains entry).
   *
   * @generated from field: repeated string fqdns = 1;
   */
  fqdns: string[] = [];

  /**
   * The same domains with whether a campaign put on them is served.
   *
   * @generated from field: repeated tracker.v1.OwnedDomain domains = 2;
   */
  domains: OwnedDomain[] = [];

  constructor(data?: PartialMessage<ListFreeDomainsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListFreeDomainsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fqdns", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "domains", kind: "message", T: OwnedDomain, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFreeDomainsResponse {
    return new ListFreeDomainsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFreeDomainsResponse {
    return new ListFreeDomainsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFreeDomainsResponse {
    return new ListFreeDomainsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFreeDomainsResponse | PlainMessage<ListFreeDomainsResponse> | undefined, b: ListFreeDomainsResponse | PlainMessage<ListFreeDomainsResponse> | undefined): boolean {
    return proto3.util.equals(ListFreeDomainsResponse, a, b);
  }
}

/**
 * OwnedDomain is one domain of a person, as a picker shows it: every one is
 * listed, readiness is told, none is hidden.
 *
 * @generated from message tracker.v1.OwnedDomain
 */
export class OwnedDomain extends Message<OwnedDomain> {
  /**
   * @generated from field: string fqdn = 1;
   */
  fqdn = "";

  /**
   * The tracker's edge serves the name now: a campaign put on it answers at once.
   *
   * @generated from field: bool serves = 2;
   */
  serves = false;

  /**
   * The workspace already holds it as a tracking domain; taking it reuses that.
   *
   * @generated from field: bool bound = 3;
   */
  bound = false;

  /**
   * A campaign may be put on it. False: another workspace holds it, or it is
   * attached elsewhere and its zone cannot take the tracker in front (reason).
   *
   * @generated from field: bool takeable = 4;
   */
  takeable = false;

  /**
   * Why it does not serve (yet) or cannot be taken; "" when it serves.
   *
   * @generated from field: string reason = 5;
   */
  reason = "";

  /**
   * Live campaigns already on it in the workspace (imported copies included).
   *
   * @generated from field: int32 campaigns = 6;
   */
  campaigns = 0;

  constructor(data?: PartialMessage<OwnedDomain>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.OwnedDomain";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fqdn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "serves", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "bound", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "takeable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "campaigns", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OwnedDomain {
    return new OwnedDomain().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OwnedDomain {
    return new OwnedDomain().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OwnedDomain {
    return new OwnedDomain().fromJsonString(jsonString, options);
  }

  static equals(a: OwnedDomain | PlainMessage<OwnedDomain> | undefined, b: OwnedDomain | PlainMessage<OwnedDomain> | undefined): boolean {
    return proto3.util.equals(OwnedDomain, a, b);
  }
}

/**
 * RenderAdLink is the ad link of a campaign, rendered by the tracker from the
 * source's own ad-link template (internal/sourcetype: AskFields / GiveFields):
 * one value per field the platform's ad account asks for, ready to paste. A
 * launcher never assembles a URL or a parameter string itself.
 *
 * @generated from message tracker.v1.RenderAdLinkRequest
 */
export class RenderAdLinkRequest extends Message<RenderAdLinkRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * UNSPECIFIED = the campaign's own traffic source.
   *
   * @generated from field: tracker.v1.TrafficSourceKind source = 2;
   */
  source = TrafficSourceKind.UNSPECIFIED;

  /**
   * Answers to the source's ask fields by ask key (Facebook: "pixel"). Laid
   * over the campaign's saved platform_params; not persisted. A wrong one is
   * an InvalidArgument named after the ask field's server field.
   *
   * @generated from field: map<string, string> asks = 3;
   */
  asks: { [key: string]: string } = {};

  /**
   * A check, not a link to paste: the campaign's address, its parameters and
   * the ad-id parameter are rendered, the source's ask rules are not applied
   * (asks are ignored) and `values` stays empty — nothing in the answer goes
   * into an ad. For a campaign that takes a link already written elsewhere
   * (a twin): the ad carries its own pixel, the tracker only has to read it.
   *
   * @generated from field: bool preview = 4;
   */
  preview = false;

  constructor(data?: PartialMessage<RenderAdLinkRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RenderAdLinkRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "source", kind: "enum", T: proto3.getEnumType(TrafficSourceKind) },
    { no: 3, name: "asks", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "preview", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RenderAdLinkRequest {
    return new RenderAdLinkRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RenderAdLinkRequest {
    return new RenderAdLinkRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RenderAdLinkRequest {
    return new RenderAdLinkRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RenderAdLinkRequest | PlainMessage<RenderAdLinkRequest> | undefined, b: RenderAdLinkRequest | PlainMessage<RenderAdLinkRequest> | undefined): boolean {
    return proto3.util.equals(RenderAdLinkRequest, a, b);
  }
}

/**
 * One rendered give field: the value and the ad-account field it goes into.
 *
 * @generated from message tracker.v1.AdLinkValue
 */
export class AdLinkValue extends Message<AdLinkValue> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string label = 2;
   */
  label = "";

  /**
   * @generated from field: string ad_field = 3;
   */
  adField = "";

  /**
   * @generated from field: string value = 4;
   */
  value = "";

  /**
   * @generated from field: string hint = 5;
   */
  hint = "";

  constructor(data?: PartialMessage<AdLinkValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.AdLinkValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ad_field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "hint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdLinkValue {
    return new AdLinkValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdLinkValue {
    return new AdLinkValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdLinkValue {
    return new AdLinkValue().fromJsonString(jsonString, options);
  }

  static equals(a: AdLinkValue | PlainMessage<AdLinkValue> | undefined, b: AdLinkValue | PlainMessage<AdLinkValue> | undefined): boolean {
    return proto3.util.equals(AdLinkValue, a, b);
  }
}

/**
 * One URL parameter the rendered link carries: the tracker-side param and the
 * platform macro that fills it.
 *
 * @generated from message tracker.v1.AdLinkParam
 */
export class AdLinkParam extends Message<AdLinkParam> {
  /**
   * @generated from field: string param = 1;
   */
  param = "";

  /**
   * @generated from field: string macro = 2;
   */
  macro = "";

  /**
   * @generated from field: string label = 3;
   */
  label = "";

  constructor(data?: PartialMessage<AdLinkParam>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.AdLinkParam";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "param", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "macro", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdLinkParam {
    return new AdLinkParam().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdLinkParam {
    return new AdLinkParam().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdLinkParam {
    return new AdLinkParam().fromJsonString(jsonString, options);
  }

  static equals(a: AdLinkParam | PlainMessage<AdLinkParam> | undefined, b: AdLinkParam | PlainMessage<AdLinkParam> | undefined): boolean {
    return proto3.util.equals(AdLinkParam, a, b);
  }
}

/**
 * @generated from message tracker.v1.RenderAdLinkResponse
 */
export class RenderAdLinkResponse extends Message<RenderAdLinkResponse> {
  /**
   * In the order the source's template declares them (Facebook: website_url,
   * url_params). Empty for a preview.
   *
   * @generated from field: repeated tracker.v1.AdLinkValue values = 1;
   */
  values: AdLinkValue[] = [];

  /**
   * The parameters inside those values.
   *
   * @generated from field: repeated tracker.v1.AdLinkParam params = 2;
   */
  params: AdLinkParam[] = [];

  /**
   * Which of them carries the platform's ad id (Facebook: sub3) — the slot a
   * reporting join reads, "" when the source has none.
   *
   * @generated from field: string ad_id_param = 3;
   */
  adIdParam = "";

  /**
   * The bare address (the campaign's public path, or its /clk/ URL).
   *
   * @generated from field: string link = 4;
   */
  link = "";

  /**
   * @generated from field: string fqdn = 5;
   */
  fqdn = "";

  /**
   * @generated from field: bool domain_serves = 6;
   */
  domainServes = false;

  constructor(data?: PartialMessage<RenderAdLinkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RenderAdLinkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "message", T: AdLinkValue, repeated: true },
    { no: 2, name: "params", kind: "message", T: AdLinkParam, repeated: true },
    { no: 3, name: "ad_id_param", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "fqdn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "domain_serves", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RenderAdLinkResponse {
    return new RenderAdLinkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RenderAdLinkResponse {
    return new RenderAdLinkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RenderAdLinkResponse {
    return new RenderAdLinkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RenderAdLinkResponse | PlainMessage<RenderAdLinkResponse> | undefined, b: RenderAdLinkResponse | PlainMessage<RenderAdLinkResponse> | undefined): boolean {
    return proto3.util.equals(RenderAdLinkResponse, a, b);
  }
}

/**
 * CampaignGroup is a named group of campaigns (decision 04).
 *
 * @generated from message tracker.v1.CampaignGroup
 */
export class CampaignGroup extends Message<CampaignGroup> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: int32 sort_order = 3;
   */
  sortOrder = 0;

  /**
   * How many live campaigns are in it.
   *
   * @generated from field: int32 campaigns = 4;
   */
  campaigns = 0;

  constructor(data?: PartialMessage<CampaignGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "campaigns", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignGroup {
    return new CampaignGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignGroup {
    return new CampaignGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignGroup {
    return new CampaignGroup().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignGroup | PlainMessage<CampaignGroup> | undefined, b: CampaignGroup | PlainMessage<CampaignGroup> | undefined): boolean {
    return proto3.util.equals(CampaignGroup, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCampaignGroupsRequest
 */
export class ListCampaignGroupsRequest extends Message<ListCampaignGroupsRequest> {
  constructor(data?: PartialMessage<ListCampaignGroupsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCampaignGroupsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCampaignGroupsRequest {
    return new ListCampaignGroupsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCampaignGroupsRequest {
    return new ListCampaignGroupsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCampaignGroupsRequest {
    return new ListCampaignGroupsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCampaignGroupsRequest | PlainMessage<ListCampaignGroupsRequest> | undefined, b: ListCampaignGroupsRequest | PlainMessage<ListCampaignGroupsRequest> | undefined): boolean {
    return proto3.util.equals(ListCampaignGroupsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCampaignGroupsResponse
 */
export class ListCampaignGroupsResponse extends Message<ListCampaignGroupsResponse> {
  /**
   * @generated from field: repeated tracker.v1.CampaignGroup groups = 1;
   */
  groups: CampaignGroup[] = [];

  constructor(data?: PartialMessage<ListCampaignGroupsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCampaignGroupsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "groups", kind: "message", T: CampaignGroup, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCampaignGroupsResponse {
    return new ListCampaignGroupsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCampaignGroupsResponse {
    return new ListCampaignGroupsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCampaignGroupsResponse {
    return new ListCampaignGroupsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCampaignGroupsResponse | PlainMessage<ListCampaignGroupsResponse> | undefined, b: ListCampaignGroupsResponse | PlainMessage<ListCampaignGroupsResponse> | undefined): boolean {
    return proto3.util.equals(ListCampaignGroupsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateCampaignGroupRequest
 */
export class CreateCampaignGroupRequest extends Message<CreateCampaignGroupRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: int32 sort_order = 2;
   */
  sortOrder = 0;

  constructor(data?: PartialMessage<CreateCampaignGroupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateCampaignGroupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCampaignGroupRequest {
    return new CreateCampaignGroupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCampaignGroupRequest {
    return new CreateCampaignGroupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCampaignGroupRequest {
    return new CreateCampaignGroupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCampaignGroupRequest | PlainMessage<CreateCampaignGroupRequest> | undefined, b: CreateCampaignGroupRequest | PlainMessage<CreateCampaignGroupRequest> | undefined): boolean {
    return proto3.util.equals(CreateCampaignGroupRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateCampaignGroupResponse
 */
export class CreateCampaignGroupResponse extends Message<CreateCampaignGroupResponse> {
  /**
   * @generated from field: tracker.v1.CampaignGroup group = 1;
   */
  group?: CampaignGroup;

  constructor(data?: PartialMessage<CreateCampaignGroupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateCampaignGroupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group", kind: "message", T: CampaignGroup },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCampaignGroupResponse {
    return new CreateCampaignGroupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCampaignGroupResponse {
    return new CreateCampaignGroupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCampaignGroupResponse {
    return new CreateCampaignGroupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCampaignGroupResponse | PlainMessage<CreateCampaignGroupResponse> | undefined, b: CreateCampaignGroupResponse | PlainMessage<CreateCampaignGroupResponse> | undefined): boolean {
    return proto3.util.equals(CreateCampaignGroupResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateCampaignGroupRequest
 */
export class UpdateCampaignGroupRequest extends Message<UpdateCampaignGroupRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: int32 sort_order = 3;
   */
  sortOrder = 0;

  constructor(data?: PartialMessage<UpdateCampaignGroupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateCampaignGroupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCampaignGroupRequest {
    return new UpdateCampaignGroupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCampaignGroupRequest {
    return new UpdateCampaignGroupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCampaignGroupRequest {
    return new UpdateCampaignGroupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCampaignGroupRequest | PlainMessage<UpdateCampaignGroupRequest> | undefined, b: UpdateCampaignGroupRequest | PlainMessage<UpdateCampaignGroupRequest> | undefined): boolean {
    return proto3.util.equals(UpdateCampaignGroupRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateCampaignGroupResponse
 */
export class UpdateCampaignGroupResponse extends Message<UpdateCampaignGroupResponse> {
  /**
   * @generated from field: tracker.v1.CampaignGroup group = 1;
   */
  group?: CampaignGroup;

  constructor(data?: PartialMessage<UpdateCampaignGroupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateCampaignGroupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group", kind: "message", T: CampaignGroup },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCampaignGroupResponse {
    return new UpdateCampaignGroupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCampaignGroupResponse {
    return new UpdateCampaignGroupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCampaignGroupResponse {
    return new UpdateCampaignGroupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCampaignGroupResponse | PlainMessage<UpdateCampaignGroupResponse> | undefined, b: UpdateCampaignGroupResponse | PlainMessage<UpdateCampaignGroupResponse> | undefined): boolean {
    return proto3.util.equals(UpdateCampaignGroupResponse, a, b);
  }
}

/**
 * Deleting a group leaves its campaigns in no group.
 *
 * @generated from message tracker.v1.DeleteCampaignGroupRequest
 */
export class DeleteCampaignGroupRequest extends Message<DeleteCampaignGroupRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteCampaignGroupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteCampaignGroupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCampaignGroupRequest {
    return new DeleteCampaignGroupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCampaignGroupRequest {
    return new DeleteCampaignGroupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCampaignGroupRequest {
    return new DeleteCampaignGroupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCampaignGroupRequest | PlainMessage<DeleteCampaignGroupRequest> | undefined, b: DeleteCampaignGroupRequest | PlainMessage<DeleteCampaignGroupRequest> | undefined): boolean {
    return proto3.util.equals(DeleteCampaignGroupRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteCampaignGroupResponse
 */
export class DeleteCampaignGroupResponse extends Message<DeleteCampaignGroupResponse> {
  constructor(data?: PartialMessage<DeleteCampaignGroupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteCampaignGroupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCampaignGroupResponse {
    return new DeleteCampaignGroupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCampaignGroupResponse {
    return new DeleteCampaignGroupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCampaignGroupResponse {
    return new DeleteCampaignGroupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCampaignGroupResponse | PlainMessage<DeleteCampaignGroupResponse> | undefined, b: DeleteCampaignGroupResponse | PlainMessage<DeleteCampaignGroupResponse> | undefined): boolean {
    return proto3.util.equals(DeleteCampaignGroupResponse, a, b);
  }
}

/**
 * CampaignCost is spend entered by hand for a period (a MANUAL campaign):
 * spread evenly over the period's days in the workspace's timezone.
 *
 * @generated from message tracker.v1.CampaignCost
 */
export class CampaignCost extends Message<CampaignCost> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string campaign_id = 2;
   */
  campaignId = "";

  /**
   * Inclusive local days, YYYY-MM-DD.
   *
   * @generated from field: string date_from = 3;
   */
  dateFrom = "";

  /**
   * @generated from field: string date_to = 4;
   */
  dateTo = "";

  /**
   * USD.
   *
   * @generated from field: string amount = 5;
   */
  amount = "";

  /**
   * @generated from field: string note = 6;
   */
  note = "";

  /**
   * @generated from field: string created_by = 7;
   */
  createdBy = "";

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt = "";

  constructor(data?: PartialMessage<CampaignCost>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignCost";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "date_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "date_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignCost {
    return new CampaignCost().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignCost {
    return new CampaignCost().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignCost {
    return new CampaignCost().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignCost | PlainMessage<CampaignCost> | undefined, b: CampaignCost | PlainMessage<CampaignCost> | undefined): boolean {
    return proto3.util.equals(CampaignCost, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCampaignCostsRequest
 */
export class ListCampaignCostsRequest extends Message<ListCampaignCostsRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  constructor(data?: PartialMessage<ListCampaignCostsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCampaignCostsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCampaignCostsRequest {
    return new ListCampaignCostsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCampaignCostsRequest {
    return new ListCampaignCostsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCampaignCostsRequest {
    return new ListCampaignCostsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCampaignCostsRequest | PlainMessage<ListCampaignCostsRequest> | undefined, b: ListCampaignCostsRequest | PlainMessage<ListCampaignCostsRequest> | undefined): boolean {
    return proto3.util.equals(ListCampaignCostsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCampaignCostsResponse
 */
export class ListCampaignCostsResponse extends Message<ListCampaignCostsResponse> {
  /**
   * @generated from field: repeated tracker.v1.CampaignCost costs = 1;
   */
  costs: CampaignCost[] = [];

  constructor(data?: PartialMessage<ListCampaignCostsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCampaignCostsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "costs", kind: "message", T: CampaignCost, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCampaignCostsResponse {
    return new ListCampaignCostsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCampaignCostsResponse {
    return new ListCampaignCostsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCampaignCostsResponse {
    return new ListCampaignCostsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCampaignCostsResponse | PlainMessage<ListCampaignCostsResponse> | undefined, b: ListCampaignCostsResponse | PlainMessage<ListCampaignCostsResponse> | undefined): boolean {
    return proto3.util.equals(ListCampaignCostsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.AddCampaignCostRequest
 */
export class AddCampaignCostRequest extends Message<AddCampaignCostRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * @generated from field: string date_from = 2;
   */
  dateFrom = "";

  /**
   * @generated from field: string date_to = 3;
   */
  dateTo = "";

  /**
   * @generated from field: string amount = 4;
   */
  amount = "";

  /**
   * @generated from field: string note = 5;
   */
  note = "";

  constructor(data?: PartialMessage<AddCampaignCostRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.AddCampaignCostRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "date_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddCampaignCostRequest {
    return new AddCampaignCostRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddCampaignCostRequest {
    return new AddCampaignCostRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddCampaignCostRequest {
    return new AddCampaignCostRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddCampaignCostRequest | PlainMessage<AddCampaignCostRequest> | undefined, b: AddCampaignCostRequest | PlainMessage<AddCampaignCostRequest> | undefined): boolean {
    return proto3.util.equals(AddCampaignCostRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.AddCampaignCostResponse
 */
export class AddCampaignCostResponse extends Message<AddCampaignCostResponse> {
  /**
   * @generated from field: tracker.v1.CampaignCost cost = 1;
   */
  cost?: CampaignCost;

  constructor(data?: PartialMessage<AddCampaignCostResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.AddCampaignCostResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cost", kind: "message", T: CampaignCost },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddCampaignCostResponse {
    return new AddCampaignCostResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddCampaignCostResponse {
    return new AddCampaignCostResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddCampaignCostResponse {
    return new AddCampaignCostResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AddCampaignCostResponse | PlainMessage<AddCampaignCostResponse> | undefined, b: AddCampaignCostResponse | PlainMessage<AddCampaignCostResponse> | undefined): boolean {
    return proto3.util.equals(AddCampaignCostResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteCampaignCostRequest
 */
export class DeleteCampaignCostRequest extends Message<DeleteCampaignCostRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteCampaignCostRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteCampaignCostRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCampaignCostRequest {
    return new DeleteCampaignCostRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCampaignCostRequest {
    return new DeleteCampaignCostRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCampaignCostRequest {
    return new DeleteCampaignCostRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCampaignCostRequest | PlainMessage<DeleteCampaignCostRequest> | undefined, b: DeleteCampaignCostRequest | PlainMessage<DeleteCampaignCostRequest> | undefined): boolean {
    return proto3.util.equals(DeleteCampaignCostRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteCampaignCostResponse
 */
export class DeleteCampaignCostResponse extends Message<DeleteCampaignCostResponse> {
  constructor(data?: PartialMessage<DeleteCampaignCostResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteCampaignCostResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCampaignCostResponse {
    return new DeleteCampaignCostResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCampaignCostResponse {
    return new DeleteCampaignCostResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCampaignCostResponse {
    return new DeleteCampaignCostResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCampaignCostResponse | PlainMessage<DeleteCampaignCostResponse> | undefined, b: DeleteCampaignCostResponse | PlainMessage<DeleteCampaignCostResponse> | undefined): boolean {
    return proto3.util.equals(DeleteCampaignCostResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCampaignOwnersRequest
 */
export class ListCampaignOwnersRequest extends Message<ListCampaignOwnersRequest> {
  constructor(data?: PartialMessage<ListCampaignOwnersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCampaignOwnersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCampaignOwnersRequest {
    return new ListCampaignOwnersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCampaignOwnersRequest {
    return new ListCampaignOwnersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCampaignOwnersRequest {
    return new ListCampaignOwnersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCampaignOwnersRequest | PlainMessage<ListCampaignOwnersRequest> | undefined, b: ListCampaignOwnersRequest | PlainMessage<ListCampaignOwnersRequest> | undefined): boolean {
    return proto3.util.equals(ListCampaignOwnersRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCampaignOwnersResponse
 */
export class ListCampaignOwnersResponse extends Message<ListCampaignOwnersResponse> {
  /**
   * @generated from field: repeated tracker.v1.CampaignOwner owners = 1;
   */
  owners: CampaignOwner[] = [];

  constructor(data?: PartialMessage<ListCampaignOwnersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCampaignOwnersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "owners", kind: "message", T: CampaignOwner, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCampaignOwnersResponse {
    return new ListCampaignOwnersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCampaignOwnersResponse {
    return new ListCampaignOwnersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCampaignOwnersResponse {
    return new ListCampaignOwnersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCampaignOwnersResponse | PlainMessage<ListCampaignOwnersResponse> | undefined, b: ListCampaignOwnersResponse | PlainMessage<ListCampaignOwnersResponse> | undefined): boolean {
    return proto3.util.equals(ListCampaignOwnersResponse, a, b);
  }
}

/**
 * CampaignOwner is one person who owns campaigns.
 *
 * @generated from message tracker.v1.CampaignOwner
 */
export class CampaignOwner extends Message<CampaignOwner> {
  /**
   * A Keycloak sub; "" = campaigns nobody owns.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * As the tracker last saw them sign in: name, else email, else "".
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * Their campaigns outside the archive.
   *
   * @generated from field: int32 campaigns = 3;
   */
  campaigns = 0;

  constructor(data?: PartialMessage<CampaignOwner>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignOwner";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "campaigns", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignOwner {
    return new CampaignOwner().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignOwner {
    return new CampaignOwner().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignOwner {
    return new CampaignOwner().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignOwner | PlainMessage<CampaignOwner> | undefined, b: CampaignOwner | PlainMessage<CampaignOwner> | undefined): boolean {
    return proto3.util.equals(CampaignOwner, a, b);
  }
}

/**
 * PreviewCampaignRules replays the campaign's own recent visits through a set
 * of buyer rules (decision 06) the way the edge checks them: top to bottom,
 * the first that holds takes the visit, whatever none takes goes to the
 * rotation. The rules are the editor's, saved or not — nothing is stored.
 * A PARAM_NOT_EQUAL rule cannot be replayed: the tracker keeps no link query
 * beyond sub1..sub20, so it takes nothing here and comes back countable=false.
 *
 * @generated from message tracker.v1.PreviewCampaignRulesRequest
 */
export class PreviewCampaignRulesRequest extends Message<PreviewCampaignRulesRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * @generated from field: repeated tracker.v1.CampaignRule rules = 2;
   */
  rules: CampaignRule[] = [];

  /**
   * The zone SCHEDULE hours are counted in — the workspace's; "" = Europe/Kyiv.
   *
   * @generated from field: string timezone = 3;
   */
  timezone = "";

  /**
   * Whole days back from now; 0 = 7.
   *
   * @generated from field: int32 days = 4;
   */
  days = 0;

  constructor(data?: PartialMessage<PreviewCampaignRulesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PreviewCampaignRulesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rules", kind: "message", T: CampaignRule, repeated: true },
    { no: 3, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreviewCampaignRulesRequest {
    return new PreviewCampaignRulesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreviewCampaignRulesRequest {
    return new PreviewCampaignRulesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreviewCampaignRulesRequest {
    return new PreviewCampaignRulesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PreviewCampaignRulesRequest | PlainMessage<PreviewCampaignRulesRequest> | undefined, b: PreviewCampaignRulesRequest | PlainMessage<PreviewCampaignRulesRequest> | undefined): boolean {
    return proto3.util.equals(PreviewCampaignRulesRequest, a, b);
  }
}

/**
 * What one rule would have taken.
 *
 * @generated from message tracker.v1.RuleReplay
 */
export class RuleReplay extends Message<RuleReplay> {
  /**
   * Visits (people and bots: a rule sees every visit) the rule took.
   *
   * @generated from field: int64 visits = 1;
   */
  visits = protoInt64.zero;

  /**
   * False when the rule cannot be replayed from what the tracker stores.
   *
   * @generated from field: bool countable = 2;
   */
  countable = false;

  constructor(data?: PartialMessage<RuleReplay>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RuleReplay";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "visits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "countable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RuleReplay {
    return new RuleReplay().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RuleReplay {
    return new RuleReplay().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RuleReplay {
    return new RuleReplay().fromJsonString(jsonString, options);
  }

  static equals(a: RuleReplay | PlainMessage<RuleReplay> | undefined, b: RuleReplay | PlainMessage<RuleReplay> | undefined): boolean {
    return proto3.util.equals(RuleReplay, a, b);
  }
}

/**
 * @generated from message tracker.v1.PreviewCampaignRulesResponse
 */
export class PreviewCampaignRulesResponse extends Message<PreviewCampaignRulesResponse> {
  /**
   * Every visit of the campaign in the window.
   *
   * @generated from field: int64 total_visits = 1;
   */
  totalVisits = protoInt64.zero;

  /**
   * One per request rule, in its order.
   *
   * @generated from field: repeated tracker.v1.RuleReplay rules = 2;
   */
  rules: RuleReplay[] = [];

  /**
   * Visits no rule took: the rotation's.
   *
   * @generated from field: int64 rest_visits = 3;
   */
  restVisits = protoInt64.zero;

  /**
   * @generated from field: int32 days = 4;
   */
  days = 0;

  constructor(data?: PartialMessage<PreviewCampaignRulesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PreviewCampaignRulesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_visits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "rules", kind: "message", T: RuleReplay, repeated: true },
    { no: 3, name: "rest_visits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreviewCampaignRulesResponse {
    return new PreviewCampaignRulesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreviewCampaignRulesResponse {
    return new PreviewCampaignRulesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreviewCampaignRulesResponse {
    return new PreviewCampaignRulesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PreviewCampaignRulesResponse | PlainMessage<PreviewCampaignRulesResponse> | undefined, b: PreviewCampaignRulesResponse | PlainMessage<PreviewCampaignRulesResponse> | undefined): boolean {
    return proto3.util.equals(PreviewCampaignRulesResponse, a, b);
  }
}

